<template>
  <cTable @checkTable="checkTable" :fields="fields" :footer="footer" :config="config" ref="table">
  </cTable>
</template>
<script>
import numFun from "@/utils/numFun";
import cTable from "@/base/common/index";

export default {
  props: {
    row: Object,
  },
  components: {
    cTable,
  },
  mounted() {
    this.$refs.table.list = this.row.children;
  },
	methods:{
		checkTable(list){
			if(!this.$page.expandCheckList)this.$page.expandCheckList = {}
			this.$page.expandCheckList[this.row.id] = list
			let checkList = Object.values(JSON.parse(JSON.stringify(this.$page.expandCheckList))).reduce((a,b)=>{
				a.push(...b)
				return a
			})
			this.$page.config.rate = !checkList.length
		}
	},
	inject:['$page'],
  data() {
    return {
			checkList:[],
      config: {
        resize: false,
        slot: "div",
        height: "300px",
        showFooter: true,
        footerCellClassName: "col-red",
        footerMethod: ({ columns, data }) => {
          const sums = [];
          columns.forEach((column) => {
            let sumCell = null;
            switch (column.property) {
              case "seq":
                sumCell = this.$t("total");
                break;
              case "total_amount_cny":
                sumCell = numFun.sumNumFun(data, column.property, 2, "format");
                break;
              case "total_amount_usd":
                sumCell = numFun.sumNumFun(data, column.property, 2, "format");
                break;
              case "total_amount_sar":
                sumCell = numFun.sumNumFun(data, column.property, 2, "format");
                break;
              case "total_amount_aed":
                sumCell = numFun.sumNumFun(data, column.property, 2, "format");
                break;
							case "total_amount_qar":
								sumCell = numFun.sumNumFun(data, column.property, 2, "format");
								break;
							case "total_amount_kwd":
								sumCell = numFun.sumNumFun(data, column.property, 2, "format");
								break;
              case "total_amount_hkd":
                sumCell = numFun.sumNumFun(data, column.property, 2, "format");
                break;
              default:
                sumCell = "-";
                break;
            }
            sums.push(sumCell);
          });
          // 返回一个二维数组的表尾合计
          return [sums];
        },
      },
      footer: {
        show: () => false,
      },
      fields: [
				{
					type: "checkbox",
					width: 60,
					fixed: "left",
				},
        {
          name: () => this.$t("expenseName"),
          minWidth: 100,
          key: "expense_item_name",
          methods: {
            render({ value }) {
              return value && value.name;
            },
          },
        },
        {
          name: () => this.$t("currencyCode"),
          key: "currency",
          minWidth: 130,
        },
        {
          name: () => this.$t("doublePrice"),
          key: "price",
          minWidth: 100,
        },
        {
          name: () => this.$t("charging_volume"),
          key: "charging_volume",
          minWidth: 100,
        },
        {
          name: () => this.$t("charge_params"),
          key: "charging_weight",
          minWidth: 170,
        },
        {
          name: () => this.$t("expType"),
          key: "unit_name_txt",
          minWidth: 170,
        },
        {
          name: () => "CNY",
          key: "total_amount_cny",
          minWidth: 100,
          isFormat: true,
        },
        {
          name: () => "USD",
          key: "total_amount_usd",
          minWidth: 100,
          isFormat: true,
        },
        {
          name: () => "SAR",
          key: "total_amount_sar",
          minWidth: 100,
          isFormat: true,
        },
        {
          name: () => "AED",
          key: "total_amount_aed",
          minWidth: 100,
          isFormat: true,
        },
				{
				  name: () => "QAR",
				  key: "total_amount_qar",
				  minWidth: 100,
				},
				{
				  name: () => "KWD",
				  key: "total_amount_kwd",
				  minWidth: 100,
				},
        {
          name: () => "HKD",
          key: "total_amount_hkd",
          minWidth: 100,
        },
      ],
    };
  },
};
</script>
